<template>
    <div class="px-10 mb-2" id="instructor-progress">
        <h3>
            Progress:
            <v-chip label color="secondary" class="ml-2 text-uppercase">
                <v-icon class="mr-1">{{ progressIcon }}</v-icon
                >{{ progress }}
            </v-chip>
        </h3>
        <v-slider
            class="my-2"
            :value="instructorProgress"
            readonly
            height="10"
            hide-details
            :step="1"
            :max="4"
            :tick-labels="tickLabels"
            ticks
            tick-size="8"
            track-color="alternate3 lighten-4"
            track-fill-color="primary"
        >
        </v-slider>
    </div>
</template>

<script>
export default {
    name: "instructor-progress",
    props: {
        progress: {
            type: String,
            required: false,
            default: "Invited",
        },
    },
    data() {
        return {
            tickLabels: [
                "Invited",
                "Registered",
                "Sessions",
                "Students",
                "Reports",
            ],
        };
    },
    computed: {
        instructorProgress() {
            return this.tickLabels.findIndex((item) => item === this.progress);
        },
        progressIcon() {
            switch (this.progress) {
                case "Invited":
                    return "mdi-email";
                case "Registered":
                    return "mdi-account-check";
                case "Sessions":
                    return "mdi-calendar-multiple";
                case "Students":
                    return "mdi-school";
                case "Reports":
                    return "mdi-chart-multiple";
            }
            return "";
        },
    },
};
</script>

<style >
#instructor-progress .v-slider--horizontal .v-slider__track-container {
    height: 6px;
}

#instructor-progress .v-slider__tick-label {
    font-size: 14px;
}
</style>